module.exports = __webpack_public_path__ + "img/store_video@2x.5b87d3e.jpg";